import { render, staticRenderFns } from "./TableProductFilters.vue?vue&type=template&id=123bc76c&scoped=true&"
import script from "./TableProductFilters.vue?vue&type=script&lang=js&"
export * from "./TableProductFilters.vue?vue&type=script&lang=js&"
import style0 from "./TableProductFilters.vue?vue&type=style&index=0&id=123bc76c&prod&lang=css&"
import style1 from "./TableProductFilters.vue?vue&type=style&index=1&id=123bc76c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123bc76c",
  null
  
)

export default component.exports